import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './large-list.scss';

import MobileLayout from './mobile-stack';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';
import TicketPurchasing from '../event_components/ticket-purchasing';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import CheckoutController from '../event_components/Checkout';
import { attendButtonIsVisible } from './utils';
import PaginationContainer from './pagination_container';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  index: PropTypes.number,
};

// eslint-disable-next-line react/prop-types
function LogoContainer({ event, settings }) {
  return (
    <Col xs={6} md={6}>
      <div className={styles.image}>
        <Logo event={event} settings={settings} />
      </div>
    </Col>
  );
}
class DetailsContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    const { event } = this.props;

    if (event.get('type') === 'google') {
      return;
    }

    this.props.onResizeComponent();
    this.setState({
      openTicketing: !this.state.openTicketing,
    });
  };
  render() {
    const { event, settings, onResizeComponent } = this.props;

    return (
      <Col xs={6} md={6} className={styles.details}>
        <CheckoutController
          variant="default"
          event={event}
          settings={settings}
          openTicketing={this.state.openTicketing}
          onResizeComponent={onResizeComponent}
          onClose={() => {
            this.setState({
              openTicketing: false,
            });
          }}
        >
          <div className={styles.info}>
            <Title event={event} className={styles.title} settings={settings} />
            <Time event={event} settings={settings} withIcon className={styles.center} />

            {(settings.get('showVenue') || settings.get('showFullAddress')) && (
              <div>
                {event.get('type') === 'google' ? (
                  <GoogleLocation event={event} />
                ) : (
                  <Location event={event} settings={settings} className={styles.location} withIcon />
                )}
              </div>
            )}
            {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} />}
            {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
            <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
            {attendButtonIsVisible(event, settings) && (
              <AttendButton settings={settings} event={event} className={styles.button} handleButtonClick={this.toggleAttendButton} />
            )}
            {settings.get('embedTicketPurchasing') && (
              <TicketPurchasing settings={settings} event={event} open={this.state.openTicketing} onResizeComponent={onResizeComponent} />
            )}
          </div>
        </CheckoutController>
      </Col>
    );
  }
}
export function LargeListEvent({ event, settings, index, onResizeComponent }) {
  const isEven = index % 2 === 0;
  const LeftSideComponent = isEven ? LogoContainer : DetailsContainer;
  const RightSideComponent = isEven ? DetailsContainer : LogoContainer;

  return (
    <Row className={cn(!settings.get('embedTicketPurchasing') ? styles.list : styles.listWithTicket, 'event')}>
      <LeftSideComponent event={event} settings={settings} onResizeComponent={onResizeComponent} />
      <RightSideComponent event={event} settings={settings} onResizeComponent={onResizeComponent} />
    </Row>
  );
}

LargeListEvent.propTypes = propTypes;

function ListContainer({ events, settings, isMobile, onResizeComponent }) {
  const Component = isMobile ? MobileLayout : LargeListEvent;

  const renderEvent = (event, index) => (
    <LocaleWrapper event={event}>
      <Component key={event.get('id')} event={event} settings={settings} index={index} onResizeComponent={onResizeComponent} />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

ListContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default ListContainer;
